import React, { PureComponent } from 'react';
import { injectIntl, defineMessages } from 'react-intl';
import ReactTable, { ReactTableDefaults } from 'react-table';

import {
  ReactTableFilterAzSearch,
  ReactTableFilterDatePicker,
  ReactTableFilterDropdown,
  ReactTableSearch,
  ReactTablePagination,
  ReactTableHeaderText,
  Loading
} from 'components';
import { Icon, Image } from 'semantic-ui-react';

import moment from 'moment';
import 'moment/locale/ko';
import 'moment/locale/ja';

import classNames from 'classnames/bind';
import styles from './AdminLog.css';
const cx = classNames.bind(styles);

moment.locale(localStorage.getItem('language'));

class AdminLog extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      expanded: {}
    };
  }

  render() {
    // 국제화 처리
    const { formatMessage } = this.props.intl;
    const { data, fromNowView, isAuth, handleChangeDateFilter, searchObj, ...rest } = this.props;
    // 필터
    const { logTypeFilter, cancleCheck, filterClose, executeFilter, onFilterCancel } = this.props;
    // 현재 페이지 이동 (하단)
    const { handlePagination } = this.props;
    const { logDetail, logDetailComponent, onRefRegister } = this.props;

    const columns = [
      {
        Header: (
          <ReactTableHeaderText
            title={defineMessages(formatMessage({ id: 'AdminLog_4', defaultMessage: '서비스No' }))}
          />
        ),
        accessor: 'serviceNo',
        sortable: true,
        resizable: false,
        minWidth: 110,
        headerClassName: cx('react-table-th'),
        className: cx('react-table-td', 'text-align-center number-text')
      },
      {
        Header: (
          <ReactTableHeaderText
            title={defineMessages(formatMessage({ id: 'AdminLog_19', defaultMessage: '서비스명' }))}
          />
        ),
        accessor: 'serviceName',
        sortable: true,
        minWidth: 143,
        headerClassName: cx('react-table-th'),
        className: cx('react-table-td sub-text')
      },
      {
        Header: <ReactTableHeaderText title={'No'} />,
        accessor: 'logNo',
        sortable: true,
        resizable: false,
        width: 72,
        headerClassName: cx('react-table-th'),
        className: cx('react-table-td', 'text-align-center number-text')
      },
      {
        Header: ({ ...rest }) => {
          const listItem = [
            {
              key: 'login',
              text: defineMessages(formatMessage({ id: 'AdminLog_6', defaultMessage: '사용자 로그인' })),
              value: 1
            },
            {
              key: 'adminlogin',
              text: defineMessages(formatMessage({ id: 'AdminLog_26', defaultMessage: '관리자로그인' })),
              value: 2
            },
            {
              key: 'system',
              text: defineMessages(formatMessage({ id: 'AdminLog_7', defaultMessage: '시스템' })),
              value: 4
            },
            {
              key: 'normal',
              text: defineMessages(formatMessage({ id: 'AdminLog_8', defaultMessage: '일반' })),
              value: 8
            }
          ];

          return (
            <ReactTableHeaderText
              title={defineMessages(formatMessage({ id: 'AdminLog_5', defaultMessage: '구분' }))}
              // filter={
              //   <ReactTableFilterDropdown
              //     isMulti
              //     listItem={listItem}
              //     filter={searchObj.filterData}
              //     handleChangeFilter={handleChangeFilter}
              //     column={rest.column.id}
              //   />
              // }
            />
          );
        },
        accessor: 'logType',
        id: 'logType',
        sortable: true,
        resizable: false,
        width: 110,
        headerClassName: cx('react-table-th', 'overflow-visible'),
        className: cx('react-table-td', 'text-align-center'),
        Cell: ({ value }) => {
          let printValue = '-';
          if (value === 1) {
            printValue = defineMessages(formatMessage({ id: 'AdminLog_6', defaultMessage: '사용자 로그인' }));
          } else if (value === 2) {
            printValue = defineMessages(formatMessage({ id: 'AdminLog_26', defaultMessage: '관리자 로그인' }));
          } else if (value === 4) {
            printValue = defineMessages(formatMessage({ id: 'AdminLog_7', defaultMessage: '시스템' }));
          } else if (value === 8) {
            printValue = defineMessages(formatMessage({ id: 'AdminLog_8', defaultMessage: '일반' }));
          } else {
            // 나머지
          }
          return printValue;
        }
      },
      {
        Header: <ReactTableHeaderText title={'API'} />,
        accessor: 'logCategory',
        sortable: true,
        width: 110,
        headerClassName: cx('react-table-th'),
        className: cx('react-table-td')
      },
      {
        Header: (
          <ReactTableHeaderText title={defineMessages(formatMessage({ id: 'AdminLog_2', defaultMessage: '이름' }))} />
        ),
        accessor: 'userName',
        sortable: true,
        resizable: false,
        minWidth: 110,
        headerClassName: cx('react-table-th'),
        className: cx('react-table-td', 'text-align-center')
      },
      {
        Header: (
          <ReactTableHeaderText title={defineMessages(formatMessage({ id: 'AdminLog_3', defaultMessage: '이메일' }))} />
        ),
        accessor: 'userEmail',
        sortable: true,
        minWidth: 199,
        headerClassName: cx('react-table-th'),
        className: cx('react-table-td')
      },
      {
        Header: (
          <ReactTableHeaderText
            title={defineMessages(formatMessage({ id: 'AdminLog_10', defaultMessage: '접속 IP' }))}
          />
        ),
        accessor: 'regIp',
        sortable: true,
        resizable: false,
        width: 125,
        headerClassName: cx('react-table-th'),
        className: cx('react-table-td', 'text-align-center')
      },
      {
        Header: ({ ...rest }) => {
          return (
            <ReactTableHeaderText
              title={defineMessages(formatMessage({ id: 'AdminLog_1', defaultMessage: '일시' }))}
              filter={
                <ReactTableFilterDatePicker
                  {...rest}
                  onChange={data => {
                    handleChangeDateFilter('RegEpoch', data);
                  }}
                />
              }
            />
          );
        },
        accessor: 'regEpoch',
        width: 177,
        sortable: true,
        resizable: false,
        headerClassName: cx('react-table-th', 'overflow-visible'),
        className: cx('react-table-td', 'text-align-center sub-text'),
        Cell: ({ value }) => {
          const dateFormat = localStorage.getItem('language') === 'en' ? 'MM/DD/YYYY' : 'YYYY-MM-DD';
          return (
            <div>
              <span className={cx('log-reg-date-normal')}>{moment.unix(value).format(dateFormat + ' HH:mm:ss')}</span>
              <span className={cx('log-reg-date-fromnow')}>{moment.unix(value).fromNow()}</span>
            </div>
          );
        }
      },
      {
        Header: (
          <ReactTableHeaderText title={defineMessages(formatMessage({ id: 'AdminLog_11', defaultMessage: '상세' }))} />
        ),
        width: 72,
        headerClassName: cx('react-table-th'),
        className: cx('react-table-td', 'text-align-center'),
        expander: true,
        Expander: ({ isExpanded }) => (
          <div className={cx('react-table-expander')}>
            {isExpanded ? (
              <Icon name="dot circle outline" color="blue" size="large" link />
            ) : (
              <Icon name="plus circle" size="large" link />
            )}
          </div>
        )
      },
      {
        Header: (
          <ReactTableHeaderText title={defineMessages(formatMessage({ id: 'AdminLog_12', defaultMessage: '작업' }))} />
        ),
        accessor: 'logTitle',
        sortable: true,
        minWidth: 390,
        headerClassName: cx('react-table-th'),
        className: cx('react-table-td')
      }
    ];

    const { TbodyComponent: tbadyWrapper } = ReactTableDefaults;
    
    
    return (
      <div className={cx('react-table-area', 'systemLog-wrap')}>
        <ReactTableSearch
          searchObj={searchObj}
          listData={data}
          //필터 영역
          filters={{
            logTypeFilter: logTypeFilter
          }}
          cancleCheck={cancleCheck}
          filterClose={filterClose}
          executeFilter={executeFilter}
          onFilterCancel={onFilterCancel}
        />
        <div className={cx('react-table')}>
          <ReactTable
            columns={columns}
            data={data}
            sortable={false}
            filterable={false}
            showPagination={false}
            showPageSizeOptions={false}
            defaultSorted={[
              {
                id: 'logNo',
                desc: true
              }
            ]}
            loadingText={defineMessages(formatMessage({ id: 'AdminLog_15', defaultMessage: '데이터 로딩중...' }))}
            LoadingComponent={({ ...rest }) => <Loading active={rest.loading} content={rest.loadingText} />}
            FilterComponent={({ ...rest }) => <div />}
            freezeWhenExpanded
            onExpandedChange={(newExpanded, index, event) => {
              // 상세보기 펼칠때만 호출
              if (newExpanded[index[0]] === false) {
                  newExpanded = {}
              } else {
                  const logNo = data[index[0]].logNo;
                  logDetail(logNo);
                  Object.keys(newExpanded).map(k => {
                      newExpanded[k] = parseInt(k) === index[0] ? {} : false
                  })
              }
              this.setState({
                  ...this.state,
                  expanded: newExpanded
              })
            }}
            expanded={this.state.expanded}
            SubComponent={row => logDetailComponent(row)}
            TbodyComponent={({ ...rest }) => (
              <div
                style={{ ...rest.style }}
                className={cx('react-table-tbody-wrapper')}
                ref={ref => {
                  onRefRegister('moveList', ref);
                }}>
                <tbadyWrapper {...rest} className={cx('rt-tbody', rest.className ? rest.className : '')} />
              </div>
            )}
            NoDataComponent={({ ...rest }) => (
              <div className={cx('noData-area')}>
                <Image src="/img/table/nodata_icon.png" />
                {defineMessages(formatMessage({ id: 'ExamTemplateList_24', defaultMessage: '데이터가 없습니다.' }))}
              </div>
            )}
            getTheadThProps={(state, rowInfo, column) => {
              const filter = [];
              if (column) {
                // 필터 처리
                if (typeof searchObj.filterData[column.id] !== 'undefined') {
                  filter.push('isFiltered');
                }
                // 정렬 제공 안하는 header
                if (!column.sortable) {
                  filter.push('no-sort');
                }

                return filter.length > 0
                  ? {
                      className: filter.join(' ')
                    }
                  : {};
              }
            }}
            {...rest}
          />
        </div>
        <ReactTablePagination
          currentPage={rest.page}
          totalPages={rest.pages ? rest.pages : 0}
          handlePagination={handlePagination}
        />
      </div>
    );
  }
}

export default injectIntl(AdminLog);



// WEBPACK FOOTER //
// ./src/script/components/admin/AdminLog.js